/* Carousel — prev/next arrows for native scroll-snap tracks.
   Not in the global bundle: emitted as its own asset (mim-carousel.js) and
   loaded by each section that renders a carousel. Markup contract:
     [data-mim-carousel]                root (one per section)
       [data-mim-carousel-arrows] hidden  wrapper, shown once JS runs
         [data-mim-carousel-prev] / [data-mim-carousel-next]
       [data-mim-carousel-track]        one or more tracks; the arrows drive
                                        the first one not inside a [hidden]
                                        ancestor (lets tabbed sections share
                                        one pair of arrows).
   Swipe / trackpad / keyboard scrolling are native; the mouse drags the
   track through the shared drag component (mim-drag.js) and, on release,
   glides on to the nearest card. */

(function () {
  'use strict';
  if (!window.Mim) return;
  const Mim = window.Mim;

  const Carousel = {
    init() {
      Mim.utils.qsa('[data-mim-carousel]').forEach((root) => this.setup(root));
      document.addEventListener('shopify:section:load', (e) => {
        Mim.utils.qsa('[data-mim-carousel]', e.target).forEach((root) => this.setup(root));
      });
      window.addEventListener('resize', Mim.utils.debounce(() => {
        Mim.utils.qsa('[data-mim-carousel]').forEach((root) => this.update(root));
      }, 100));
    },

    setup(root) {
      if (root.dataset.mimCarouselReady) return;
      root.dataset.mimCarouselReady = 'true';

      const prev = Mim.utils.qs('[data-mim-carousel-prev]', root);
      const next = Mim.utils.qs('[data-mim-carousel-next]', root);
      if (prev) Mim.utils.on(prev, 'click', () => this.page(root, -1));
      if (next) Mim.utils.on(next, 'click', () => this.page(root, 1));

      const update = Mim.utils.debounce(() => this.update(root), 60);
      Mim.utils.qsa('[data-mim-carousel-track]', root).forEach((track) => {
        Mim.utils.on(track, 'scroll', update, { passive: true });
        if (Mim.modules.drag) {
          Mim.modules.drag.attach(track, { snapTo: (left, v) => this.snapPoint(track, left, v) });
        }
      });
      this.update(root);
    },

    // Nearest card start to where the release momentum would carry the row:
    // exponential decay like native touch scrolling (time constant ~325ms →
    // the row coasts v·325px), so a flick travels on and a slow release stays.
    snapPoint(track, left, v) {
      const max = track.scrollWidth - track.clientWidth;
      const projected = Math.max(0, Math.min(max, left + v * 325));
      const base = track.getBoundingClientRect().left - track.scrollLeft
        + (parseFloat(getComputedStyle(track).scrollPaddingLeft) || 0);
      let best = 0;
      Array.from(track.children).forEach((card) => {
        const at = Math.min(max, Math.max(0, card.getBoundingClientRect().left - base));
        if (Math.abs(at - projected) < Math.abs(best - projected)) best = at;
      });
      return best;
    },

    track(root) {
      return Mim.utils.qsa('[data-mim-carousel-track]', root)
        .find((t) => !t.closest('[hidden]')) || null;
    },

    // Scroll by the visible width, so a "page" is the slides currently in view.
    page(root, dir) {
      const track = this.track(root);
      if (!track) return;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollBy({ left: dir * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
    },

    // Show the arrows only when the active track overflows; disable at the ends.
    update(root) {
      const arrows = Mim.utils.qs('[data-mim-carousel-arrows]', root);
      if (!arrows) return;
      const track = this.track(root);
      const max = track ? track.scrollWidth - track.clientWidth : 0;
      arrows.hidden = max <= 1;
      if (!track) return;
      const prev = Mim.utils.qs('[data-mim-carousel-prev]', root);
      const next = Mim.utils.qs('[data-mim-carousel-next]', root);
      if (prev) prev.disabled = track.scrollLeft <= 1;
      if (next) next.disabled = track.scrollLeft >= max - 1;
    },
  };

  Mim.ready(() => Mim.register('carousel', Carousel));
})();
